//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { QCard, QCardSection } from 'quasar'

export default {
  name: 'ScoreBar',
  components: {
    QCard,
    QCardSection
  },
  computed: {
    score () {
      return this.$store.state.score
    },
    resume () {
      return this.$store.state.score.Resume()
    }
  }
}
